var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTapIconReverse = function SvgTapIconReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.577 9.06v6.04h6.04c1.51 0 2.894-1.258 2.894-2.894 0-.755-.252-1.51-.881-2.013L20.358 6.92a2.81 2.81 0 0 0-4.026 0 3.417 3.417 0 0 0-.755 2.14Zm0 6.04h-6.04c-1.51 0-2.895 1.258-2.895 2.894 0 .755.252 1.51.881 2.014l3.272 3.271a2.81 2.81 0 0 0 4.027 0c.503-.503.88-1.258.88-2.013V15.1h-.126Zm0-15.1c8.305 0 15.1 6.795 15.1 15.1s-6.795 15.1-15.1 15.1-15.1-6.795-15.1-15.1S7.272 0 15.577 0Z",
    fill: "currentColor"
  })));
};

export default SvgTapIconReverse;